export * from './ProductCardV2ProductDetailsContainer';
